/**
 * @module actions/AudioPlayer
 */
import { createAction } from 'typesafe-actions';

import * as D from './deps';

interface TrackEndErrorParams {
  sourceId: $TSFixMe;
  token: $TSFixMe;
  isRecoverable: $TSFixMe;
}

export const trackEndError = createAction(
  D.Constants.AudioPlayer.AudioPlayerActions.TRACK_END_ERROR,
  (params: TrackEndErrorParams) => params,
)<TrackEndErrorParams>();
export type TrackEndErrorAction = ReturnType<typeof trackEndError>;

export function logStartPlaying() {
  return {
    type: D.Constants.Playback.ActionTypes.PLAYBACK_LOG_START_PLAYING,
  };
}

type AudioActiveProviderParams = $TSFixMe;

interface AudioActiveProviderPayload {
  provider: AudioActiveProviderParams;
}

export const activeProvider = createAction(
  D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_ACTIVE_PROVIDER,
  (provider: AudioActiveProviderParams) => ({ provider }),
)<AudioActiveProviderPayload>();
export type AudioActiveProviderAction = ReturnType<typeof activeProvider>;
